import MappingTopBox from "../CreatorTools/MappingTool/components/MappingTopBox";
import SourceTextsToSkipComponent from "./SourceTextsToSkipComponent";

function ProcessorConfigPage() {
	return (
		<div className="min-h-screen bg-gray-50">
			<MappingTopBox />
			<div className="ml-8 mr-8">
				<h1 className="text-3xl font-bold text-gray-800 mb-2 mt-4">Processor Config</h1>
				<p className="text-gray-600 mb-6">
					Configuration for the line item processor. These settings are fed into the template-selection agent at runtime.
				</p>

				<SourceTextsToSkipComponent />
			</div>
		</div>
	);
}

export default ProcessorConfigPage;
